import { MIMEtypes } from '@/shared/types/files'

const CONTACT_AVATAR_MIME_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'image/png',
  'image/bmp',
  'image/dng',
  'image/tiff',
  'image/tif',
])

const normalizeImageMime = (mime: string) => {
  const value = mime.toLowerCase()
  if (value === 'image/jpg') return 'image/jpeg'
  if (value === 'image/tif') return 'image/tiff'
  return value
}

export const resolveImageMimeType = (fileName: string, fileType = ''): string => {
  const fromType = normalizeImageMime(fileType.trim())
  if (fromType.startsWith('image/')) return fromType

  const extension = fileName.split('.').pop()?.toLowerCase() ?? ''
  const fromExtension = MIMEtypes.get(extension) ?? ''
  return normalizeImageMime(fromExtension)
}

export const isAllowedContactAvatarMime = (mime: string): boolean =>
  CONTACT_AVATAR_MIME_TYPES.has(normalizeImageMime(mime))

export const ensureFileMimeType = (file: File, mimeType: string): File => {
  if (file.type && normalizeImageMime(file.type) === normalizeImageMime(mimeType)) {
    return file
  }

  return new File([file], file.name, {
    type: normalizeImageMime(mimeType),
    lastModified: file.lastModified,
  })
}
